import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://taskflowapi.webseller.in/api';

// Login user
export const login = async (credentials) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// Register company and admin user
export const register = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/auth/register`, userData);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
};

// Logout user
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

// Get current user
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    return JSON.parse(userStr);
  }
  return null;
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

// Get dashboard URL based on user role
export const getDashboardUrl = () => {
  const user = getCurrentUser();
  if (!user) return '/login';
  
  switch (user.role) {
    case 'admin':
      return '/admin/dashboard';
    case 'manager':
      return '/manager/dashboard';
    case 'employee':
      return '/employee/dashboard';
    default:
      return '/login';
  }
};

// Get tasks URL based on user role
export const getTasksUrl = () => {
  const user = getCurrentUser();
  if (!user) return '/login';
  
  switch (user.role) {
    case 'admin':
      return '/admin/tasks';
    case 'manager':
      return '/manager/tasks';
    case 'employee':
      return '/employee/tasks';
    default:
      return '/login';
  }
};